import React, { useState, useEffect } from 'react';
import DataTable from './DataTable';
import { GetAuthTokenAsync } from './GetAuthToken';
import ContentDownload from './ContentDownload';
import { Routes, Route } from 'react-router-dom';
import { AuthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from './authConfig';

const App: React.FC = () => {
  const [data, setData] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useMsalAuthentication(InteractionType.Redirect, loginRequest);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await GetAuthTokenAsync();
      const accessToken: string = result;

      const requestOptions: RequestInit = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        }
      };

      const response = await fetch(process.env.REACT_APP_WEB_API_URL+`Content`, requestOptions);
      const responseData = await response.json();

      if (!response.ok) {
        const error = (responseData && responseData.message) || response.status;
        throw new Error(error);
      }

      setData(responseData as string[]);
    } catch (error) {
      console.error('There was an error!', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (itemName: string) => {
    const result = await GetAuthTokenAsync();
    const accessToken: string = result;

    const requestOptions: RequestInit = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      }
    };

    const response = await fetch(process.env.REACT_APP_WEB_API_URL+`Content/${itemName}`, requestOptions);
    
    if (response.ok) {
      setData(data.filter(item => item !== itemName));
    } else {
      console.error(`Failed to delete item ${itemName}.`);
    }
  };

    if (isLoading) {
        return <div>Loading....</div>;
    }

    return (
        <AuthenticatedTemplate>
            <Routes>
                <Route path="/content/" element={<DataTable data={data} onDelete={handleDelete} />} />
                <Route path="/ContentDownload/content/:itemName" element={<ContentDownload />} />
                <Route path='/agent/' Component={() => { window.location.href = process.env.REACT_APP_WEB_URL; return null; }} />
                <Route path="/" Component={() => { window.location.href = "https://teams.microsoft.com/l/chat/0/0?users=28:c6eac7a0-d409-4d54-bc40-9161bb7af6da"; return null;}} />
            </Routes>
        </AuthenticatedTemplate>
    );
};

export default App;
